<osp-dialog>
  <ng-template ospTemplate="content">
    <div class="content-wrapper">
      @switch ($activePhase()) {
        @case (MigrationDialogPhase.BEFORE_MIGRATION) {
          <ng-container [ngTemplateOutlet]="beforePhaseContent" />
        }
        @case (MigrationDialogPhase.MIGRATION_IN_PROGRESS) {
          <ng-container [ngTemplateOutlet]="inProgressPhaseContent" />
        }
        @case (MigrationDialogPhase.AFTER_MIGRATION) {
          <ng-container [ngTemplateOutlet]="afterPhaseContent" />
        }
      }
    </div>
  </ng-template>

  <ng-template ospTemplate="footer">
    @if ($actionOptions(); as actions) {
      <osp-action-panel [actions]="actions" />
    }
  </ng-template>
</osp-dialog>

<ng-template #beforePhaseContent>
  <span class="text-base">{{ 'revolution.shared.migration.migrationDialog.messageOnInit' | translate }}</span>
</ng-template>

<ng-template #inProgressPhaseContent>
  <div class="flex flex-column align-items-center gap-3">
    <span class="text-base">{{
      'revolution.shared.migration.migrationDialog.migrationInProgressTitle' | translate
    }}</span>
    <osp-spinner [size]="'medium'" />
  </div>
</ng-template>

<ng-template #afterPhaseContent>
  <div class="text-base mb-3">{{ 'revolution.shared.migration.migrationDialog.migrationResultTitle' | translate }}</div>
  @if ($migrationResultFormatted(); as result) {
    @for (entity of result; track entity) {
      <div class="migration-result-line">
        <span class="migration-result-line__label">{{ entity.label }}:</span>
        <div class="migration-result-line__count">
          <i class="result-icon result-icon__success" [ngClass]="IconKey.MigrationStatusSuccess | icon"></i>
          <span>{{ entity.success }}</span>
        </div>
        @if (entity.failure > 0) {
          <div class="migration-result-line__count">
            <i class="result-icon result-icon__failure" [ngClass]="IconKey.MigrationStatusFailure | icon"></i>
            <span>{{ entity.failure }}</span>
          </div>
        }
      </div>
    }
    @if ($showFailureHint()) {
      <osp-messages
        [messages]="[
          {
            severity: 'error',
            detail: 'revolution.shared.migration.migrationDialog.migrationResultHintFailure' | translate
          }
        ]"
        [closable]="false"
      />
    } @else {
      <osp-messages
        [messages]="[
          {
            severity: 'success',
            detail: 'revolution.shared.migration.migrationDialog.migrationResultHintSuccess' | translate
          }
        ]"
        [closable]="false"
      />
    }
  } @else {
    <span class="text-base">
      {{ 'revolution.shared.migration.migrationDialog.migrationResultNoData' | translate }}
    </span>
  }
</ng-template>
